export default __webpack_public_path__ + "static/media/mpd 2041 icon.075f01bb.svg";